import React from "react";
import { Instagram, Facebook } from "lucide-react";
import { SITE, buildWaLink } from "../data/site";
import { useLang } from "../data/i18n";
import { Waves } from "./Decor";
import BrandLogo from "./BrandLogo";

export default function Footer() {
    const { t, prefix } = useLang();
    return (
        <footer
            className="relative bg-ocean-900 text-cream pt-24 pb-10 overflow-hidden"
            data-testid="site-footer"
        >
            <div className="absolute top-0 left-0 right-0 pointer-events-none rotate-180">
                <Waves className="w-full h-14" color="#77CABA" />
            </div>

            <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
                    <div className="md:col-span-5">
                        <BrandLogo variant="light" height={80} className="mb-6" />
                        <p className="text-cream/70 text-sm leading-relaxed max-w-sm">
                            {t.footer.description}
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <p className="text-[10px] uppercase tracking-[0.3em] font-bold text-lagoon mb-5">
                            {t.footer.explore}
                        </p>
                        <ul className="space-y-3 text-sm">
                            <li><a href={`${prefix}/#experiences`} className="text-cream/80 hover:text-coral underline-grow">{t.nav.experiences}</a></li>
                            <li><a href={`${prefix}/#about`} className="text-cream/80 hover:text-coral underline-grow">{t.nav.about}</a></li>
                            <li><a href={`${prefix}/#offres`} className="text-cream/80 hover:text-coral underline-grow">{t.nav.offres}</a></li>
                            <li><a href={`${prefix}/#addons`} className="text-cream/80 hover:text-coral underline-grow">{t.nav.addons}</a></li>
                            <li><a href={`${prefix}/#contact`} className="text-cream/80 hover:text-coral underline-grow">{t.nav.contact}</a></li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <p className="text-[10px] uppercase tracking-[0.3em] font-bold text-lagoon mb-5">
                            {t.footer.contact}
                        </p>
                        <ul className="space-y-3 text-sm">
                            <li>
                                <a
                                    href={buildWaLink()}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-cream/80 hover:text-coral underline-grow"
                                    data-testid="footer-whatsapp"
                                >
                                    WhatsApp · {SITE.whatsapp.number}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`tel:${SITE.phone.replace(/\s/g, "")}`}
                                    className="text-cream/80 hover:text-coral underline-grow"
                                    data-testid="footer-phone"
                                >
                                    Tél · {SITE.phone}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`mailto:${SITE.email}`}
                                    className="text-cream/80 hover:text-coral underline-grow"
                                    data-testid="footer-email"
                                >
                                    {SITE.email}
                                </a>
                            </li>
                            <li className="text-cream/60">{SITE.location}</li>
                        </ul>
                        <div className="flex gap-4 mt-6">
                            <a
                                href={SITE.instagram}
                                aria-label="Instagram"
                                className="w-10 h-10 flex items-center justify-center border border-cream/30 text-cream/80 hover:text-coral hover:border-coral transition-colors"
                                data-testid="social-instagram"
                            >
                                <Instagram size={16} strokeWidth={1.6} />
                            </a>
                            <a
                                href={SITE.facebook}
                                aria-label="Facebook"
                                className="w-10 h-10 flex items-center justify-center border border-cream/30 text-cream/80 hover:text-coral hover:border-coral transition-colors"
                                data-testid="social-facebook"
                            >
                                <Facebook size={16} strokeWidth={1.6} />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="border-t border-cream/15 pt-8 mb-8">
                    <p
                        className="text-cream/60 text-xs leading-relaxed max-w-3xl"
                        data-testid="legal-disclaimer"
                    >
                        {t.footer.legal}
                    </p>
                </div>

                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-cream/50 text-xs">
                    <p>© {new Date().getFullYear()} Exotik Trips · {t.footer.rights}</p>
                    <div className="flex items-center gap-6">
                        <a
                            href="/admin/login"
                            className="text-cream/40 hover:text-cream/80 transition-colors duration-300 uppercase tracking-[0.25em] text-[10px] font-semibold"
                            data-testid="footer-admin-link"
                        >
                            {t.footer.admin}
                        </a>
                        <p className="uppercase tracking-[0.3em] font-semibold">
                            {t.footer.madeIn}
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}
